export default () => import(/* webpackChunkName: 'coffee/wechat-community/coupon-centre/home' */ './Home');